import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as DepositActions from 'web-app/react/entities/deposits/actions';
import Deposit from 'web-app/react/entities/deposits/model';

import * as Actions from './actions';

const AddDepositModalState = Record({
    isVisible: false,
    isEditing: false,
    isSubmitting: false,
    isDeleting: false,
    isReturning: false,
    isCanclingReturn: false,
    showPaidExternally: false,
    searchResults: List(),
    childId: null,
    institutionId: null,
    deposit: null,
});

export default handleActions(
    {
        [Actions.showAddDepositModal.type]: (state, {payload}) => {
            const {childId, institutionId, showPaidExternally} = payload;
            return AddDepositModalState({
                isVisible: true,
                childId,
                institutionId,
                showPaidExternally,
            });
        },

        [Actions.showEditDepositModal.type]: (state, {payload}) => {
            const {childId, institutionId, deposit} = payload;
            return AddDepositModalState({
                isVisible: true,
                isEditing: true,
                showPaidExternally: deposit.status === Deposit.Status.PAID_EXTERNALLY,
                childId,
                institutionId,
                deposit,
            });
        },

        [Actions.searchForBillPayerSuccess.type]: (state, {payload}) =>
            state.merge({
                searchResults: payload.searchItems,
            }),

        [Actions.hideDepositModal.type]: () => AddDepositModalState(),

        [DepositActions.returnDeposit.type]: state => state.merge({isReturning: true}),
        [DepositActions.returnDepositFailed.type]: state => state.merge({isReturning: false}),
        [DepositActions.returnDepositSuccess.type]: () => AddDepositModalState(),

        [DepositActions.deleteDeposit.type]: state => state.merge({isDeleting: true}),
        [DepositActions.deleteDepositFailed.type]: state => state.merge({isDeleting: false}),
        [DepositActions.deleteDepositSuccess.type]: () => AddDepositModalState(),

        [DepositActions.create.type]: state => state.merge({isSubmitting: true}),
        [DepositActions.createFailed.type]: state => state.merge({isSubmitting: false}),
        [DepositActions.createSuccess.type]: () => AddDepositModalState(),

        [DepositActions.deleteDepositReturn.type]: state => state.merge({isCanclingReturn: true}),
        [DepositActions.deleteDepositReturnFailed.type]: state => state.merge({isCanclingReturn: false}),
        [DepositActions.deleteDepositReturnSuccess.type]: () => AddDepositModalState(),
    },
    AddDepositModalState(),
);
